import React from 'react'

function NoMatch() {
    return <div>
        <h2>Ups, algo salió mal</h2>
        </div>
  }

  export default NoMatch;